<template>
    <ul class="relative flex justify-center items-center py-5 lg:py-9 border-b border-zinc-300 space-x-10">
        <li
            class="flex items-center"
            v-for="(step, index) in steps"
            :key="index"
        >
            <div class="w-10 h-10 flex justify-center items-center rounded-full"
                :class="{
                    'bg-green-600 text-white': isPastStep(step.number),
                    'bg-green-600/60 text-white': isCurrentStep(step.number),
                    'border-2 border-slate-400 text-slate-400': isUpcomingStep(step.number),
                }"
            >
                <span class="text-xl lg:text-3xl font-semibold font-division-heading" v-text="step.number"></span>
            </div>
            <span class="ml-3 font-medium leading-tight" :class="{ 'hidden lg:block': !isCurrentStep(step.number) }" v-html="step.text"></span>
        </li>
    </ul>
</template>

<script>
import { get } from 'lodash';
export default {
    data: () => ({
        currentStep: 1,
        steps: [
            {
                number: 1,
                text: 'Location you<br>need help in',
            },
            {
                number: 2,
                text: 'Tell us about<br>your legal matter',
            },
            {
                number: 3,
                text: 'Get<br>Connected',
            },
        ],
        progressSteps: {
            1: 1,
            2: 2,
            3: 2,
            4: 3,
            5: 4
        }
    }),

    created() {
        this.$event.$on('step:on-step', (step) => {
            this.currentStep = get(this.progressSteps, step)
        });
    },

    methods: {
        isPastStep(number) {
            return this.currentStep > number;
        },
        isCurrentStep(number) {
            return this.currentStep == number;
        },
        isUpcomingStep(number) {
            return this.currentStep < number;
        }
    }
}
</script>
